<template>
    <el-main class="app_border"  v-loading="loading">
        <img src="../assets/banneruser.png"  class="hidden-sm-and-down userbanner" />
      <div class="userinfo">
          <img :src="user.avatar" class="avatar" />
          <p class="username">{{user.username}}</p>
          <p>{{user.introduction}}</p>
          <p><span>当前账号余额：{{user.jine/100}}元</span><el-button @click="showchonzhi" type="primary" size="mini" class="chonzhibtn">充值</el-button></p>
          <img src="../assets/userad.png" class="userad hidden-sm-and-down" />
      </div>
        <el-menu :default-active="activeIndex" class="el-menu-demo app_info_display" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1">我的购买</el-menu-item>
        <el-menu-item index="2">我的应用</el-menu-item>
        <el-menu-item index="3" >卖出订单</el-menu-item>
        <el-menu-item index="4" >我的评论</el-menu-item>
        </el-menu>
        <div v-show="showmyapp" class="app_productlist">
            <el-row class="app_item" v-for="(item,index) in uploadapplist" :key="item.id" >
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="24">
                    <div :class="getimgclass">
                        <img @click="gotoshop(item)" v-lazy="item.app_src"/>
                    </div>

                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="24" class="app_infolist">
                    <p  @click="gotoshop(item)">
                    应用名称：{{item.app_name}}
                    </p>



                    <p>
                        价格：{{item.sp_price}}元
                    </p>

                    <p>
                        评分：
                        <el-rate
                                class="ratebar"
                                v-model="item.app_rate"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="{value}">
                        </el-rate>
                    </p>
                    <el-button  @click="editapp(item)" size="mini" type="danger" >编辑</el-button>
                    <span v-show="item.sp_downs>0" class="downnums">[安装{{item.sp_downs}}次]</span>
                </el-col>
            </el-row>
            <div v-show="uploadapppages!=1" class="app_loadmore"  @click="getmyuploadlist">{{loadinguploadtext}}</div>
        </div>
        <div v-show="showmyorder" class="app_productlist">
            <el-row class="app_item" v-for="(item,index) in orderlist"  >
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="24">
                    <div :class="getimgclass">
                        <img @click="gotoshop(item)" v-lazy="item.app_src"/>
                    </div>

                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="24" class="app_infolist">
                    <p  @click="gotoshop(item)">
                    应用名称：{{item.app_name}}
                    </p>
                    <p >
                        购买时间：{{item.ordertime}}
                    </p>
                    <p >
                        购买用户：{{item.username}}
                    </p>
                    <p  v-if="item.receiveemail!=''">
                        接收邮箱：{{item.receiveemail}}
                    </p>
                    <p v-if="item.beizhu!=''">
                        备注：{{item.beizhu}}
                    </p>
                    <el-tooltip  v-if="item.state==0" class="item " effect="dark" content="点击更改发货状态" placement="top-start" >
                        <el-button ref="changeorderid"  size="mini" type="danger" @click="changeorder(item,$event)" >{{item.mystate}}</el-button>
                    </el-tooltip>

                    <el-button   v-if="item.state==1" disabled size="mini" type="info" >{{item.mystate}}</el-button>
                    <el-button   v-if="item.state==-1" disabled size="mini" type="warning" >买家未支付</el-button>
                    <el-button   v-if="item.state==-1" @click="editmyorder(item)" size="mini" type="danger" >修改订单金额</el-button>
                    <el-button   v-if="item.state==2&&item.maijiahascomment==false" @click="pingjiahuifu(item)" size="mini" type="success" >评价回复</el-button>
                    <el-button   v-if="item.state==2&&item.maijiahascomment==true" disabled size="mini" type="success" >已评价回复</el-button>
                </el-col>
            </el-row>
            <div v-show="orderapppages!=1" class="app_loadmore"  @click="getorderlist">{{loadingordertext}}</div>
        </div>
        <div v-show="showmycomment" class="app_productlist">
            <ul class="mycommentlist">
                <li v-for="item in commentlist">
                    <p>
                        应用名称：{{item.sptitle}}
                    </p>

                    <p>
                        评论时间：{{item.addtime}}
                    </p>
                    <p>
                        评论：{{item.comment}}
                    </p>
                    <p>
                        评分：  <el-rate
                            class="ratebar"
                            v-model="item.rate"
                            disabled
                            show-score
                            text-color="#ff9900"
                            score-template="{value}">
                    </el-rate>
                    </p>
                    <div>
                        <el-button   size="mini" type="danger" @click="gotoshop(item)" >查看应用信息</el-button>
                    </div>
                </li>
            </ul>
            <div v-show="commentapppages!=1" class="app_loadmore"  @click="getmycommentlist">{{loadingcommenttext}}</div>
        </div>
        <div v-show="showpayapp" class="app_productlist">
            <el-row class="app_item" v-for="(item,index) in user.datalist" :key="item.Id" >
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="24">
                    <div :class="getimgclass">
                        <img @click="gotoshop(item)" v-lazy="item.app_src"/>
                    </div>

                </el-col>
                <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="24" class="app_infolist">
                    <p  @click="gotoshop(item)">
                    应用名称：{{item.app_name}}
                    </p>
                    <p >
                    购买时间：{{item.ordertime}}
                    </p>
                    <p >
                        购买价格：{{item.price}}元
                    </p>
                    <el-button v-if="item.state==-1" @click="wanchengzhifu(item)" size="mini" type="success" >去完成支付</el-button>
                    <el-button v-if="item.state==-1" @click="delorder(item)" size="mini" type="success" >删除订单</el-button>
                    <el-button  @click="gotoshop(item)" size="mini" type="danger" >查看详情</el-button>
                    <el-button v-if="item.state==1"  @click="querenshouhuo(item,$event)" size="mini" type="danger" >确认收货</el-button>
                    <el-button v-if="item.state==0"   size="mini" type="warning" disabled>等待商家发货</el-button>
                    <el-button v-if="item.state==2&&item.userhascomment==false"  @click="postpinglun(item)" size="mini" type="danger" >添加评论</el-button>
                    <el-button v-if="item.state==2&&item.userhascomment==true"  disabled size="mini" type="danger" >已评论</el-button>
                </el-col>
            </el-row>
            <div v-show="payapppages!=1&&payapppages!=0" class="app_loadmore"  @click="getmypaylist">{{loadingtext}}</div>
            <div v-show="flagopen" class="resultmsg">
                <el-alert
                        :closable="false"
                        title="没有找到相关应用"
                        type="warning">
                </el-alert>
            </div>
        </div>
        <el-dialog
                title="评论"
                :visible.sync="dialogVisible"
                class="mydialog"
                :before-close="handleClose">
            <el-form ref="form" :model="commentform" label-width="80px">
                <el-form-item label="应用名称">
                    <b>{{commentform.sptitle}}</b>
                </el-form-item>

            <el-form-item label="应用评论">
                <el-input type="textarea" v-model="commentform.comment"></el-input>
            </el-form-item>
            <el-form-item label="应用评分">
                <el-rate
                        v-model="commentform.rate"
                        show-text>
                </el-rate>
            </el-form-item>
            </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button  size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button  size="small" type="primary" @click="submitcomment">确 定</el-button>
  </span>
        </el-dialog>

        <el-dialog
                title="充值"
                :visible.sync="centerDialogVisible"
                class="mydialog"
                center>
            <el-form  name="chonzhifom" label-width="80px" size="mini" :action="this.$store.state.baseurl + 'appstore/aliapytransfer'" method="post" target="_blank">

                    <el-form-item label="金额(元):">
                        <el-input name="money" v-model="chonzhimoney"></el-input>
                    </el-form-item>
               <input type="hidden" name="accesstoken" v-model="this.$store.state.accesstoken" />
                <button @click="checkinput" class="el-button el-button--primary el-button--small popchonzhibtn" type="button">
                    提交
                </button>
            </el-form>


        </el-dialog>

        <el-dialog
                title="提示"
                :visible.sync="mycenterDialogVisible"
                class="mydialog"
                center>
            <span>如果确认充值成功，请点击确认！</span>
  <span slot="footer" class="dialog-footer">
    <el-button size="small"  @click="messagechonzhifail">充值失败</el-button>
      <el-button size="small"  type="primary" @click="goumaiscuuess">充值成功</el-button>
  </span>
        </el-dialog>

        <el-dialog
                title="回复评论"
                :visible.sync="huifudialogVisible"
                class="mydialog"
                :before-close="handleClose">
            <el-form ref="form" :model="huifucommentform" label-width="80px">
                <el-form-item label="应用名称">
                    <b>{{huifucommentform.sptitle}}</b>
                </el-form-item>

                <el-form-item label="评论用户">
                    <el-input type="text" disabled v-model="huifucommentform.username"></el-input>
                </el-form-item>

                <el-form-item label="对方评论">
                    <el-input type="textarea" disabled v-model="huifucommentform.comment"></el-input>
                </el-form-item>

                <el-form-item label="对方评分">
                    <el-rate
                            class="ratebar"
                            v-model="huifucommentform.rate"
                            disabled
                            show-score
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                </el-form-item>
                <el-form-item label="回复评论">
                    <el-input type="textarea" v-model="huifucommentform.spcomment"></el-input>
                </el-form-item>
            </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button  size="small" @click="huifudialogVisible = false">取 消</el-button>
      <el-button  size="small" type="primary" @click="submithuifucomment">确 定</el-button>
  </span>
        </el-dialog>

        <el-dialog
                title="提示"
                :visible.sync="zhifucenterDialogVisible"
                class="mydialog"
                center>
            <el-form  name="goumaifom" label-width="80px" size="mini" :action="this.$store.state.baseurl + 'appstore/aliapbuyytransfer'" method="post" target="_blank">
                <input type="hidden" name="receiveemail" v-model="paycurrentapp.receiveemail" />
                <input type="hidden" name="beizhu" v-model="paycurrentapp.beizhu" />
                <input type="hidden" name="spid" v-model="paycurrentapp.spid" />
                <input type="hidden" name="accesstoken" v-model="this.$store.state.accesstoken" />
                <input type="hidden" name="money" v-model="paycurrentapp.sp_price" />
            </el-form>
            <el-button type="primary" @click="zhifubaobuy" size="“small">支付宝支付</el-button>
            <el-button type="warning" @click="buyyue"  size="“small">使用余额支付</el-button>

        </el-dialog>

    <!--购买回调-->
        <el-dialog
                title="提示"
                :visible.sync="goumaimycenterDialogVisible"
                class="mydialog"
                center>
            <span>如果确购买成功，请点击确认！</span>
  <span slot="footer" class="dialog-footer">
    <el-button size="small"  @click="messagebuyfail">购买失败</el-button>
      <el-button size="small"  type="primary" @click="goumaiscuuess">购买成功</el-button>
  </span>
        </el-dialog>

    <!--修改订单金额-->
        <el-dialog
                title="修改订单金额"
                :visible.sync="orderjinecenterDialogVisible"
                class="mydialog"
                center>
            <el-form  name="chonzhifom" label-width="80px" size="mini" >

                <el-form-item label="金额(元):">
                    <el-input name="money" v-model="editorder.ordereditejine"></el-input>
                </el-form-item>
                <input type="hidden" name="accesstoken" v-model="this.$store.state.accesstoken" />
                <button @click="editorderjine" class="el-button el-button--primary el-button--small popchonzhibtn" type="button">
                提交
                </button>
            </el-form>


        </el-dialog>

    </el-main>
</template>
        <script>
            import axios from 'axios'
            export default{
                name:"User",
                        data(){
                    return {
                        editorder:{
                            id:0,
                            ordereditejine:0
                        },
                        orderjinecenterDialogVisible:false,
                        goumaimycenterDialogVisible:false,
                        zhifucenterDialogVisible:false,
                        huifudialogVisible:false,
                        huifucommentform:[],

                        chonzhimoney:5,
                        commentform:{
                            spid:0,
                            sptitle:'',
                            comment:'',
                            rate:3,
                            accesstoken:''
                        },
                        mycenterDialogVisible:false,
                        centerDialogVisible:false,
                        dialogVisible: false,
                        commentlist:[],//评论列表
                        orderlist:[],//卖出订单列表
                        uploadapplist:[], //我的应用列表
                        payapppages:0,
                        commentapppages:0,
                       orderapppages:0,
                        uploadapppages:0,
                        loadingtext:'点击加载更多',
                        loadinguploadtext:'点击加载更多',
                        loadingordertext:'点击加载更多',
                        loadingcommenttext:'点击加载更多',
                        flagopen:false,
                        showpayapp:true,
                        showmyapp:false,
                        showmyorder:false,
                        showmycomment:false,
                        activeIndex: "1",
                        loading:false,
                        user:[],
                        applist:[],
                        form:{
                            uid:0,
                            accesstoken:''
                        },
                        formpayapp:{
                            page:0,
                            accesstoken:''
                        },
                        foruploadapp:{
                            page:1,
                            accesstoken:''
                        },
                        fororderapp:{
                            page:1,
                            accesstoken:''
                        },
                        formcommentapp:{
                            page:1,
                            accesstoken:''
                        },
                        paycurrentapp:[]
                    }
                },
                mounted:function(){
                    this.form.uid=this.$route.query.uid
                    this.loading = true
                    var _this = this;
                    // 设置一个开关来避免重负请求数据
                    var sw = true;


                    _this.form.accesstoken=this.$store.state.accesstoken
                    var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.form));
                    axios.post(this.$store.state.baseurl + 'appstore/getusername', params).then(function (response) {
                        _this.loading = false
                        _this.user=response.data
                        _this.formpayapp.page=2
                        _this.payapppages =_this.user.pagenums
                        if(response.data.match('权限验证失败')){
                            _this.$message('会话过期，重新登录');
                            _this.$store.state.loginstate = false
                            _this.$store.state.showloginform = true
                            setTimeout(function(){
                                _this.$router.push({name:'Index',params:{}})
                            },2000)

                            return false
                        }


                        _this.loading = false

                    }).catch(function (error) {
                        console.log(error);
                    });

                },
                methods:{
                    delorder(item){
                        var _this=this
                        var postdata={
                            accesstoken:_this.$store.state.accesstoken,
                            id:item.Id
                        }
                        this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            _this.loading = true
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/delorder', params).then(function (response) {
                            _this.loading = false

                            if(response.data.match('ok|')){
                                _this.user.datalist.forEach(function (val, index) {
                                    if(val.Id==item.Id){
                                       //删除代码
                                        _this.user.datalist.splice(index,1)
                                        console.log(_this.user.datalist)
                                    }

                                })

                                _this.$message('订单删除成功');
                            }else if(response.data.match('error|')){
                                _this.$message('订单金额删除失败');
                            }

                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }


                        }).catch(function (error) {
                            console.log(error);
                        });
                    }).catch(() => {
                        this.$message({
                                type: 'info',
                                message: '已取消删除'
                            });
                });



                    },
                    editmyorder(item){
                       this.editorder.id=item.Id
                        this.editorder.ordereditejine=item.price
                        this.orderjinecenterDialogVisible=true
                    },
                    editorderjine(){
                        var _this=this
                        if(isNaN(Number(_this.editorder.ordereditejine))){
                            _this.$message('金额在0-50000万之间')
                            return
                        }
                        if(_this.editorder.ordereditejine<0||_this.editorder.ordereditejine>50000){
                            _this.$message('金额在0-50000万之间')
                            return
                        }
                        _this.orderlist.forEach(function (val, index) {
                                   if(val.Id==_this.editorder.id){
                                      val.price =_this.editorder.ordereditejine
                                   }

                                })

                        //提交修改金额
                        var sw = true;
                        var postdata={
                            accesstoken:_this.$store.state.accesstoken,
                            id:_this.editorder.id,
                            jine:_this.editorder.ordereditejine
                        }

                        _this.loading = true
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/editorderjine', params).then(function (response) {
                            _this.loading = false
                            _this.orderjinecenterDialogVisible=false
                            console.log(response)
                                    if(response.data.match('ok|')){
                                        _this.$message('订单金额修改成功');
                                    }else if(response.data.match('error|')){
                                        _this.$message('订单金额修改失败');
                                    }

                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }


                        }).catch(function (error) {
                            console.log(error);
                        });


                    },
                    goumaiscuuess(){
                          window.location.reload()
                    },
                    messagebuyfail(){
                        this.goumaimycenterDialogVisible = false
                        this.$alert('请检查支付宝账单里是否购买成功', '提示', {
                            confirmButtonText: '确定'

            });
                    },
                    messagechonzhifail(){
                        this.mycenterDialogVisible=false
                        this.goumaimycenterDialogVisible = false
                        this.$alert('请检查支付宝账单里是否有充值成功记录', '提示', {
                            confirmButtonText: '确定'

                        });
                    },
                    editapp(item){
                       this.$router.push({name:'EditApp',params:{id:item.Id},query:{id:item.Id}})
                    },
                    pingjiahuifu(item){
                        this.loading = true
                        var _this = this;
                        var orderid=item.Id
                        // 设置一个开关来避免重负请求数据
                        var sw = true;
                        var postdata={
                            accesstoken:_this.$store.state.accesstoken,
                            spid:item.spid,
                            commentuid:item.uid
                        }

                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(this.$store.state.baseurl + 'appstore/getcommentbyspidanduid', params).then(function (response) {
                            _this.loading = false

                            console.log(response)

                            if(response.data==null){

                                _this.$message('对方还没评论，无法回复评论')
                                return false
                            }

                            _this.huifucommentform=response.data
                            _this.huifucommentform.orderid=orderid
                            _this.huifucommentform.spcomment=''
                            _this.huifudialogVisible=true
                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }


                            _this.loading = false

                        }).catch(function (error) {
                            console.log(error);
                        });


                    },
                    submithuifucomment(){
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;
                        var postdata={
                            accesstoken:_this.$store.state.accesstoken,
                            orderid:_this.huifucommentform.orderid,
                            spid:_this.huifucommentform.spid,
                            cmid:_this.huifucommentform.Id,
                            spcomment:_this.huifucommentform.spcomment
                        }
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/updatecommentbyspuid', params).then(function (response) {
                            _this.loading = false


                            if(response.data.match('ok')){
                                _this.huifudialogVisible=false
                                _this.$message(response.data.replace('ok|',''))
                                return false
                            }
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }




                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    querenshouhuo(item,e){
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;
                        //this.centerDialogVisible=false
                        var postdata={
                            orderid:item.Id,
                            accesstoken:_this.$store.state.accesstoken
                        }

                        var _tagert=e.currentTarget
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/confirmorder', params).then(function (response) {
                            _this.loading = false


                            if(response.data.match('ok')){
                                //更改发货状态
                                _tagert.innerHTML="<span>已确认收货</span>"
                                _tagert.setAttribute("disabled","disabled")
                                _tagert.className ="el-button el-button--info el-button--mini is-disabled"
                                _this.$message(response.data.replace('ok|',''))
                                return false
                            }
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }




                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    wanchengzhifu(item){
                        this.paycurrentapp=item

                       this.zhifucenterDialogVisible =true
                    },
                    zhifubaobuy(){
                        this.goumaimycenterDialogVisible =true
                        this.zhifucenterDialogVisible =false
                        document.goumaifom.submit()
                    },
                    buyyue(){
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;
                        //this.centerDialogVisible=false
                        var postdata={
                            spid:_this.paycurrentapp.spid,
                            beizhu:_this.paycurrentapp.beizhu,
                            receiveemail:_this.paycurrentapp.receiveemail,
                            accesstoken:_this.$store.state.accesstoken
                        }


                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(postdata));
                        axios.post(_this.$store.state.baseurl + 'appstore/buyappinyue', params).then(function (response) {
                            _this.loading = false


                            if(response.data.match('ok')){
                                _this.$message(response.data.replace('ok|',''))
                                _this.centerDialogVisible=false
                                return false
                            }
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }




                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    checkinput(){
                        var money_reg = /\d{1,4}/;
                        if('' == this.chonzhimoney || !money_reg.test(this.chonzhimoney)){
                            this.$message('充值金额必须为数值')
                            return false;
                        }
                        if(this.chonzhimoney<0||this.chonzhimoney>20000){
                            this.$message('充值金额必须大于0小于2万')
                            return false;
                        }
                        this.mycenterDialogVisible=true
                        this.centerDialogVisible=false
                        document.chonzhifom.submit();
                    },
                    showchonzhi(){
                        this.centerDialogVisible=true
                    },
                    getmycommentlist(){
                        this.loading = true
                        this.loadingcommenttext = '加载中...'
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        if (_this.formcommentapp.page <= _this.commentapppages) {
                            _this.formcommentapp.accesstoken=this.$store.state.accesstoken
                            if(_this.formcommentapp.page==1){
                                _this.formcommentapp.page=2
                            }

                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.formcommentapp));
                            axios.post(this.$store.state.baseurl + 'appstore/getmycommentlist', params).then(function (response) {

                                if(response.data.data.length==0){
                                    _this.commentlist=[]
                                    _this.loading = false
                                    _this.flagopen=true
                                    _this.loadingcommenttext = ''
                                    return false
                                }
                                _this.flagopen=false

                                response.data.data.forEach(function (val, index) {
                                    _this.commentlist.push(val);
                                    _this.commentapppages =val.pagenums
                                    //   console.log(val);
                                })

                                _this.loading = false
                                if (_this.formcommentapp.page == _this.commentapppages){
                                    _this.loadingcommenttext = '我也是有底线的'
                                }else{
                                    _this.loadingcommenttext = '点击加载更多'
                                }

                                if(_this.formcommentapp.page==2){
                                    _this.formcommentapp.page=3
                                }else{
                                    _this.formcommentapp.page++
                                }
                                // _this.articles = response.data

                            }).catch(function (error) {
                                console.log(error);
                            });
                        }else{

                            _this.loading = false
                            _this.loadingcommenttext = '我也是有底线的'
                        }
                    },
                    submitcomment(){

                        //receivepostappcomment
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;

                        this.commentform.accesstoken=this.$store.state.accesstoken
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(this.commentform));
                        axios.post(this.$store.state.baseurl + 'appstore/receivepostappcomment', params).then(function (response) {
                            _this.loading = false

                            console.log(response.data)
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('ok')){
                                _this.commentform.comment=''
                                _this.commentform.rate=3
                                _this.commentform.spid=0
                                _this.commentform.sptitle=''
                                _this.dialogVisible =false
                                _this.$message(response.data.replace('ok|',''))
                                return false
                            }

                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }


                            _this.loading = false

                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    handleClose(done) {
                        this.huifudialogVisible = false
                        this.dialogVisible =false
                },
                    postpinglun(item){
                        this.commentform.spid=item.spid
                        this.commentform.sptitle=item.app_name
                        this.dialogVisible =true
                    },
                    changeorder(item,e){
                        this.loading = true
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        var orderdata={
                            orderid:item.Id,
                            accesstoken:this.$store.state.accesstoken
                        }
                        var _tagert=e.currentTarget
                        var params = 'ajax=' + encodeURIComponent(JSON.stringify(orderdata));
                        axios.post(this.$store.state.baseurl + 'appstore/changeorder', params).then(function (response) {
                            _this.loading = false

                           console.log(response.data)
                            if(response.data.match('error')){

                                _this.$message(response.data.replace('error|',''))
                                return false
                            }
                            if(response.data.match('ok')){
                                //更改发货状态
                                _tagert.innerHTML="<span>已发货，等待对方收货</span>"
                                _tagert.setAttribute("disabled","disabled")
                                _tagert.className ="el-button el-button--info el-button--mini is-disabled"
                                _this.$message(response.data.replace('ok|',''))
                                return false
                            }

                            if(response.data.match('权限验证失败')){
                                _this.$message('会话过期，重新登录');
                                _this.$store.state.loginstate = false
                                _this.$store.state.showloginform = true
                                setTimeout(function(){
                                    _this.$router.push({name:'Index',params:{}})
                                },2000)

                                return false
                            }


                            _this.loading = false

                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    getorderlist(){
                        this.loading = true
                        this.loadingordertext = '加载中...'
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        if (_this.fororderapp.page <= _this.orderapppages) {
                            _this.fororderapp.accesstoken=this.$store.state.accesstoken
                            if(_this.fororderapp.page==1){
                                _this.fororderapp.page=2
                            }

                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.fororderapp));
                            axios.post(this.$store.state.baseurl + 'appstore/getmyorderlist', params).then(function (response) {

                                if(response.data.data.length==0){
                                    _this.orderlist=[]
                                    _this.loading = false
                                    _this.flagopen=true
                                    _this.loadingordertext = ''
                                    return false
                                }
                                _this.flagopen=false

                                response.data.data.forEach(function (val, index) {
                                    _this.orderlist.push(val);
                                    _this.orderapppages =val.pagenums
                                    //   console.log(val);
                                })

                                _this.loading = false
                                if (_this.fororderapp.page == _this.orderapppages){
                                    _this.loadingordertext = '我也是有底线的'
                                }else{
                                    _this.loadingordertext = '点击加载更多'
                                }

                                if(_this.fororderapp.page==2){
                                    _this.fororderapp.page=3
                                }else{
                                    _this.fororderapp.page++
                                }
                                // _this.articles = response.data

                            }).catch(function (error) {
                                console.log(error);
                            });
                        }else{

                            _this.loading = false
                            _this.loadingordertext = '我也是有底线的'
                        }
                    },
                    getmyuploadlist(){
                        this.loading = true
                        this.loadinguploadtext = '加载中...'
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        if (_this.foruploadapp.page <= _this.uploadapppages) {
                            _this.foruploadapp.accesstoken=this.$store.state.accesstoken

                            if(_this.foruploadapp.page==1){
                                _this.foruploadapp.page=2
                            }
                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.foruploadapp));
                            axios.post(_this.$store.state.baseurl + 'appstore/getmyuploadlist', params).then(function (response) {

                                if(response.data.data.length==0){
                                    _this.uploadapplist=[]
                                    _this.loading = false
                                    _this.flagopen=true
                                    _this.loadinguploadtext = ''
                                    return false
                                }
                                _this.flagopen=false


                                _this.loading = false
                                response.data.data.forEach(function (val, index) {
                                    _this.uploadapplist.push(val);
                                    _this.uploadapppages =val.pagenums
                                    //   console.log(val);
                                })


                                if (_this.foruploadapp.page == _this.uploadapppages){
                                    _this.loadinguploadtext = '我也是有底线的'
                                }else{
                                    _this.loadinguploadtext = '点击加载更多'
                                }

                                if(_this.foruploadapp.page==2){
                                    _this.foruploadapp.page=3
                                }else{
                                    _this.foruploadapp.page++
                                }
                                // _this.articles = response.data

                            }).catch(function (error) {
                                console.log(error);
                            });
                        }else{

                            _this.loading = false
                            _this.loadinguploadtext = '我也是有底线的'
                        }
                    },
                    getmypaylist(){
                        this.loading = true
                        this.loadingtext = '加载中...'
                        var _this = this;
                        // 设置一个开关来避免重负请求数据
                        var sw = true;


                        if (_this.formpayapp.page <= _this.payapppages) {
                            _this.formpayapp.accesstoken=this.$store.state.accesstoken
                            var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.formpayapp));
                            axios.post(this.$store.state.baseurl + 'appstore/getmypaylist', params).then(function (response) {

                                if(response.data.data.length==0){
                                    _this.user.datalist=[]
                                    _this.loading = false
                                    _this.flagopen=true
                                    _this.loadingtext = ''
                                    return false
                                }
                                _this.flagopen=false

                                response.data.data.forEach(function (val, index) {
                                    _this.user.datalist.push(val);
                                    _this.payapppages =val.pagenums
                                    //   console.log(val);
                                })

                                _this.loading = false
                                if (_this.formpayapp.page == _this.payapppages){
                                    _this.loadingtext = '我也是有底线的'
                                }else{
                                    _this.loadingtext = '点击加载更多'
                                }

                                _this.formpayapp.page++
                                // _this.articles = response.data

                            }).catch(function (error) {
                                console.log(error);
                            });
                        }else{

                            _this.loading = false
                            _this.loadingtext = '我也是有底线的'
                        }
                    },
                    gotoshop(item){
                        this.$router.push({name: 'ShopInfo',params: {id:item.spid},query: {id:item.spid}})
                    },

                    handleSelect(key)
                    {

                        switch(key){
                            case '1':
                                this.showpayapp=true
                                this.showmyapp=false
                                this.showmyorder=false
                                this.showmycomment=false
                                break;
                            case '2':
                                this.showpayapp=false
                                this.showmyapp=true
                                this.showmyorder=false
                                this.showmycomment=false
                                this.foruploadapp.page=0
                                this.uploadapplist=[]
                                this.getmyuploadlist()
                                break;
                            case '3':
                                this.showpayapp=false
                                this.showmyapp=false
                                this.showmyorder=true
                                this.showmycomment=false
                                this.fororderapp.page=0
                                this.orderlist=[]
                                this.getorderlist()
                                break;
                            case '4':
                                this.showpayapp=false
                                this.showmyapp=false
                                this.showmyorder=false
                                this.showmycomment=true
                                this.formcommentapp.page=0
                                this.commentlist=[]
                                this.getmycommentlist()

                                break;

                        }

                    }
                },
                computed:{

                    getimgclass:function(){
                        var userAgentInfo = navigator.userAgent;

                        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
                        var _class='_imgthumb'
                        for (var v = 0; v < Agents.length; v++) {
                            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                                _class='xs-_imgthumb'
                                break;
                            }


                        }
                        return _class
                    },
                    getmainclass:function(){
                        var userAgentInfo = navigator.userAgent;

                        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
                        var _class='app_items'
                        for (var v = 0; v < Agents.length; v++) {
                            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                                _class='xs_app_items'
                                break;
                            }


                        }
                        return _class
                    }
                }
            }
        </script>


// WEBPACK FOOTER //
// src/components/User.vue